import { computed } from 'vue'
import { useApiStore } from '../stores/apiStore.js'

export function useSections() {
  const store = useApiStore()

  const sections = computed(() => store.sections)
  const loading = computed(() => store.sectionsLoading)
  const error = computed(() => store.sectionsError)
  const hasSections = computed(() => store.hasSections)

  const getByKey = (key) => {
    return store.getSectionByKey(key)
  }

  const getTitle = (key, fallback = '') => {
    const section = store.getSectionByKey(key)
    return section?.title || fallback
  }

  const getSubtitle = (key, fallback = '') => {
    const section = store.getSectionByKey(key)
    return section?.subtitle || fallback
  }

  const load = async () => {
    return store.loadSections()
  }

  return {
    sections,
    loading,
    error,
    hasSections,
    getByKey,
    getTitle,
    getSubtitle,
    load
  }
}
